(() => {
    const defaultSliderOptions = {
        start: 0,
        range: {
            "min": 0,
            "max": 0
        },
        step: 1
    };

    class CampaignWizardCustomiseController {
        campaignTemplateId;
        $scope;
        $injector;
        PermissionService;
        $state;
        CampaignsService;
        LocalisationService;
        ErrorService;
        $uibModal;
        $timeout;
        SMSHelperService;
        CampaignWizardService;
        DashboardConfig;
        moment;

        constructor(
            $scope,
            $injector,
            PermissionService,
            $state,
            CampaignsService,
            LocalisationService,
            ErrorService,
            $uibModal,
            $timeout,
            SMSHelperService,
            CampaignWizardService,
            DashboardConfig,
            moment,
            $element
        ) {
            this.campaignTemplateId = null;
            this.$scope = $scope;
            this.$injector = $injector;
            this.PermissionService = PermissionService;
            this.$state = $state;
            this.CampaignsService = CampaignsService;
            this.LocalisationService = LocalisationService;
            this.ErrorService = ErrorService;
            this.$uibModal = $uibModal;
            this.$timeout = $timeout;
            this.SMSHelperService = SMSHelperService;
            this.CampaignWizardService = CampaignWizardService;
            this.DashboardConfig = DashboardConfig;
            this.moment = moment;
            this.isLoadingEstimates = false;
            this.$element = $element;
        }

        $onInit() {
            this.userContext = this.PermissionService.userContext;
            this.isLoading = true;
            this.twoPercentCustomers = 0;
            this.fivePercentCustomers = 0;
            this.tenPercentCustomers = 0;
            this.twoPercentSales = 0;
            this.fivePercentSales = 0;
            this.tenPercentSales = 0;
            this.averageCustomerOrderAmount = 0;
            this.maxAdditionalNewCustomers = 0;
            this.enrollAdditionalNewCustomers = false;
            this.sliderCustomerCount = 0;
            this.StoreName = this.userContext.getCurrentContextName();
            this.ShowCustomerSlider = false;
            this.busyProcessingCampaign = false;
            this.noAvailableStartDates = false;
            this.noAvailableEndDates = false;

            this.CampaignWizardService.CheckUserAccessToCampaignManagement();

            this.format = this.LocalisationService.DatePickerFormat;

            this.startDateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                showWeeks: false,
                dateDisabled: this.setDisabledStartDates.bind(this),
                showDatePicker: false
            };

            this.endDateOptions = {
                formatYear: 'yy',
                startingDay: 1,
                showWeeks: false,
                dateDisabled: this.setDisabledEndDates.bind(this),
                showDatePicker: false
            };

            this.communicationMessageTypes = window.Dashboard.CommunicationMessageType;
            this.pushNotificationMessagePart = window.Dashboard.PushNotificationMessagePart;
            this.isLoading = false;

            this.sliderEventHandlers = {
                update: (values, _, __) => {
                    // Value gets sent through as string from the slider
                    this.sliderCustomerCount = parseInt(values);
                    this.recalculateValues();
                }
            };

            this.hasInboxMessage = this.CampaignWizardService.HasInboxMessage;
            this.hasPushMessage = this.CampaignWizardService.HasPushMessage;
            this.getCommunicationTypeTags = this.CampaignWizardService.GetCommunicationTypeTags;


            this.campaignTemplateId = this.$state.params.CampaignTemplateId;
            this.loadData();
        }

        goToPreviousTab() {
            this.$state.go(
                window.Dashboard.helpers.stateHelper.getParentState(
                    this.$state.current.name
                )
            );
        }

        goToNextTab() {
            if (!this.campaign.selectedTargetSource
                && !this.campaign.TargetCustomersSource) {
                this.ErrorService.showError("No target source selected", null);
                return;
            }

            if (!this.isCommunicationDateValid()) {
                return;
            }

            this.CampaignWizardService.Campaign = this.campaign;
            this.$state.go(
                window.Dashboard.helpers.stateHelper.getParentState(
                    this.$state.current.name
                ) + ".summary",
                {
                    storeId: this.$state.params.storeId,
                    brandId: this.$state.params.brandId,
                    CampaignTemplateId: this.$state.params.CampaignTemplateId
                });
        }

        isCommunicationDateValid() {
            if (this.campaign.TemplateActions.Vouchers.length === 0
                || this.campaign.TemplateActions.Communications.length === 0) {
                return true;
            }

            const voucherExpiryDate = new Date(
                this.LocalisationService.combineDateTimeAndFormat(
                    this.campaign.PublishEndDate,
                    this.campaign.PublishEndTime,
                    this.LocalisationService.Configuration.DateTimeFormat
                )
            );

            let isCommunicationDateValid = true;

            for (const item of this.campaign.TemplateActions.Communications) {
                const communicationSendDate = new Date(
                    this.LocalisationService.combineDateTimeAndFormat(
                        item.PublishDate,
                        item.PublishTime,
                        this.LocalisationService.Configuration.DateTimeFormat
                    )
                );

                if (communicationSendDate >= voucherExpiryDate) {
                    this.ErrorService.showError(
                        "The Communication Send Date must be earlier than the Voucher Expiry Date",
                        null
                    );
                    isCommunicationDateValid = false;
                    break;
                }
            }

            return isCommunicationDateValid;
        }

        isSameDay(
            date1,
            date2
        ) {
            const dateOne = new this.moment(date1);
            const dateTwo = new this.moment(date2);
            return dateOne.isSame(
                dateTwo,
                "day"
            );
        }

        async targetSourceChanged(newTargetSourceId) {
            if (newTargetSourceId === this.campaign.selectedTargetSource) {
                return;
            }
            const originalSelection = this.campaign.selectedTargetSource;
            try {
                this.isLoadingEstimates = true;
                const customerEstimates = await this.CampaignsService.GetCustomerEstimatesFromCampaignTargetSourceId(
                    newTargetSourceId,
                    this.campaign.CampaignTemplateGuid,
                    this.campaign.BrandId,
                    this.campaign.StoreId
                );
                this.campaign.selectedTargetSource = newTargetSourceId;
                this.campaign.MaxCustomers = customerEstimates.data.TotalCustomers;
                this.campaign.CustomersOptedInForSMS = customerEstimates.data.CanSMS;
                this.campaign.CustomersOptedInForSMSOnly = customerEstimates.data.CanSMSOnly;
                this.campaign.CustomersOptedInForPush = customerEstimates.data.CanPush;
                this.campaign.CustomersOptedInForPushOnly = customerEstimates.data.CanPushOnly;
                this.campaign.CustomersOptedInForEmail = customerEstimates.data.CanEmail;
                this.campaign.AverageOrderValuePerCustomer = customerEstimates.data.AverageOrderValue;
                this.initialiseCustomerEstimates(true);
            } catch (ex) {
                this.campaign.selectedTargetSource = originalSelection;
                this.selectTargetSourceRadioButton(originalSelection);
                this.ErrorService.showError(
                    "An error occurred while loading the customer estimates",
                    ex
                );
            } finally {
                this.isLoadingEstimates = false;
                this.$scope.$apply();
            }
        }

        selectTargetSourceRadioButton(targetSourceId) {
            this.$timeout(() => {
                const
                    selector = `#target-source-${targetSourceId}`,
                    el = this.$element.find(selector);
                if (!el || !el.length) {
                    this.ErrorService.showError(
                        `Unable to select target source in list (${selector}) - please report this bug.`
                    );
                    return;
                }
                el[0].checked = true;
            });
        }

        initialiseWithCampaign(
            campaign,
            shouldInitialiseCampaignProperties
        ) {
            this.initialisingStartDate = !shouldInitialiseCampaignProperties;
            this.initialisingEndDate = !shouldInitialiseCampaignProperties;
            this.campaign = campaign;
            window.__campaign = campaign;
            const userHasCampaignDesignerAccess = this.PermissionService.doesUserHavePermission(
                window.Dashboard.Models.Lookups.Permissions.CampaignDesignerAccess
            );
            this.campaign.CampaignTemplateTargetSources = this.campaign.CampaignTemplateTargetSources.filter(x =>
                x.StatusId !== window.Dashboard.Models.Lookups.CampaignTargetSourceStatuses.Archived &&
                (x.StatusId !== window.Dashboard.Models.Lookups.CampaignTargetSourceStatuses.Test || userHasCampaignDesignerAccess))

            if (!this.campaign.selectedTargetSource
                && this.campaign.CampaignTemplateTargetSources.length > 0) {
                this.campaign.selectedTargetSource = this.campaign.CampaignTemplateTargetSources[0].CampaignTargetSourceId;
            }

            this.selectTargetSourceRadioButton(this.campaign.selectedTargetSource)

            // If there are no available start dates then we need to show an error & return
            if (this.campaign.AvailableStartDates.length === 0) {
                this.noAvailableStartDates = true;
                return;
            }

            this.startDateOptions.minDate = new Date(this.campaign.AvailableStartDates[0]);
            this.startDateOptions.maxDate =
                new Date(this.campaign.AvailableStartDates[this.campaign.AvailableStartDates.length - 1]);

            if (shouldInitialiseCampaignProperties) {
                this.CampaignWizardService.InitialiseCommunications(
                    this.campaign.TemplateActions.Communications,
                    this.LocalisationService
                );
                this.campaign.PublishStartDate = this.startDateOptions.minDate;
            }

            // Hide the slider if this is a menuscript only campaign
            this.ShowCustomerSlider = (
                    this.CampaignWizardService.HasVouchers(this.campaign) ||
                    this.CampaignWizardService.HasCommunications(this.campaign)
                )
                && !this.noAvailableStartDates;

            this.$scope.$watch(
                "$ctrl.campaign.PublishStartDate",
                this.PublishStartDateChanged.bind(this)
            );
            this.$scope.$watch(
                "$ctrl.campaign.PublishEndDate",
                this.PublishEndDateChanged.bind(this)
            );

            this.$scope.$watch(() => this.campaign.PublishStartTime, () => {
                this.formatCommunicationMessages();
            });
            this.$scope.$watch(() => this.campaign.PublishEndTime, this.formatCommunicationMessages.bind(this));

            // Changing the maxAdditionalNewCustomers or disabling this feature
            // requires us to recalculate the values
            this.$scope.$watchGroup([
                "$ctrl.maxAdditionalNewCustomers",
                "$ctrl.enrollAdditionalNewCustomers",
                "$ctrl.sliderCustomerCount"
            ], () => {
                if (!this.enrollAdditionalNewCustomers) {
                    this.maxAdditionalNewCustomers = 0;
                }

                this.recalculateValues();
            });

            this.initialiseCustomerEstimates(shouldInitialiseCampaignProperties);
        }

        showPromotionDateAndTimeForVouchersAndMenuscripts() {
            if (this.noAvailableStartDates) {
                return false;
            }
            if (!this.campaign ||
                !this.campaign.TemplateActions ||
                !this.campaign.TemplateActions.Vouchers ||
                !this.campaign.TemplateActions.Menuscripts) {
                return false;
            }

            return this.campaign.TemplateActions.Vouchers.length > 0
                || this.campaign.TemplateActions.Menuscripts.length > 0;
        }

        initialiseCustomerEstimates(shouldInitialiseCampaignProperties) {
            this.campaign.SelectedSMSCount = this.campaign.CustomersOptedInForSMS;
            this.averageCustomerOrderAmount = this.LocalisationService.formatCurrency(
                this.campaign.AverageOrderValuePerCustomer
            );

            let customerCount = shouldInitialiseCampaignProperties
                ? this.campaign.MaxCustomers
                : this.campaign.SelectedCustomerCount;

            this.setupCustomerSlider(customerCount);
        }

        setupCustomerSlider(customerCount) {
            if (this.campaign.MaxCustomers > 0) {
                if (customerCount > this.campaign.MaxCustomers) {
                    this.maxAdditionalNewCustomers = customerCount - this.campaign.MaxCustomers;
                    customerCount = this.campaign.MaxCustomers;
                    this.enrollAdditionalNewCustomers = true;
                }

                this.campaign.SelectedCustomerCount = customerCount
                this.sliderCustomerCount = this.campaign.SelectedCustomerCount;
            }
        }

        loadData() {
            if (!this.campaignTemplateId) {
                return;
            }

            this.$scope.$root.isLoading = true;
            this.isLoading = true;

            if (this.CampaignWizardService.Campaign) {
                this.initialiseWithCampaign(
                    this.CampaignWizardService.Campaign,
                    false
                );
                this.$scope.$root.isLoading = false;
                this.isLoading = false;
                this.setMinMaxVariablesOnScope();
                this.$scope.$applyAsync();
                return;
            }

            this.CampaignsService.getCampaignTemplate(
                this.campaignTemplateId,
                this.userContext.StoreId,
                this.userContext.BrandId
            ).then(result => {
                    this.initialiseWithCampaign(
                        new window.Dashboard.Models.Campaign()
                            .initialiseCampaign(result.data),
                        true
                    );
                },
                err => {
                    this.ErrorService.showError(
                        "An error occurred while loading the campaign",
                        err
                    );
                }
            ).finally(() => {
                this.$scope.$root.isLoading = false;
                this.isLoading = false;
            });
        }

        getMinVoucherTime(publishDate) {
            let currentDate = new Date();

            if (publishDate < currentDate) {
                currentDate = this.TimeRoundedUpToFiveMinutes(currentDate);
                return this.LocalisationService.combineDateTime(
                    publishDate,
                    this.LocalisationService.formatDateTime(
                        currentDate,
                        "HH:mm"
                    )
                );
            }

            return publishDate;
        }

        setMinMaxVariablesOnScope() {
            if (this.campaign.TemplateActions.Vouchers.length === 0) {
                return;
            }

            this.setDefaultMaxVoucherTimes();

            if (this.isSameDay(
                this.campaign.PublishStartDate,
                this.campaign.PublishEndDate)
            ) {
                this.setVoucherIsSameDayTimes();
            } else {
                this.minEndTime = this.getMinVoucherTime(
                    this.campaign.PublishEndDate
                );
            }

            this.minStartTime = this.getMinVoucherTime(
                this.campaign.PublishStartDate
            );
        }

        formatCommunicationMessage(
            message,
            templateValues,
            shortURLResolved
        ) {
            const template = _.template(message.Content);
            templateValues.ShortURL = message.CommunicationTypeId === window.Dashboard.CommunicationMessageType.SMS
                ? `<a href=\"${shortURLResolved}\" target=\"_blank\">${this.DashboardConfig.ShortUrlPlaceholder}</a>`
                : this.DashboardConfig.ShortUrlPlaceholder
            message.FormattedContent = template(templateValues);

            if (message.CommunicationTypeId === window.Dashboard.CommunicationMessageType.PushNotification) {
                message.PushNotificationContent = JSON.parse(message.FormattedContent);
            }

            const smsContentToCount = message.FormattedContent
                .replace(`<a href=\"${shortURLResolved}\" target=\"_blank\">`, "")
                .replace("</a>", "")
                .replace(this.DashboardConfig.ShortUrlPlaceholder, this.DashboardConfig.LongestShortUrl);

            const SMSCountObject = this.SMSHelperService.getSMSCount(
                smsContentToCount,
                null,
                null,
                0,
                0
            );

            message.MessageParts = SMSCountObject.smsCount;
        }

        /**
         * This function is fired to update the communication content that is displayed on the UI with the replaced placeholders
         * Also updates the message parts counter
         */
        formatCommunicationMessages() {
            const startDate = new this.moment(this.campaign.PublishStartTime);
            const endDate = new this.moment(this.campaign.PublishEndTime);
            const dateFormat = this.campaign.DateFormat;
            const timeFormat = this.campaign.TimeFormat;
            const term = this.campaign.CampaignLevelId === Dashboard.Models.Lookups.CampaignLevels.Brand ? "BL" : "SL";
            const selectedTargetSource = this.campaign.CampaignTemplateTargetSources.find(x => x.CampaignTargetSourceId === this.campaign.selectedTargetSource);
            const analyticsCode = selectedTargetSource ? selectedTargetSource.AnalyticsCode : "";
            const shortURLResolved = `${this.campaign.LandingPageURL}?utm_source=${encodeURI("Campaign Manager")}&utm_medium=${encodeURI("SMS")}&utm_campaign=${encodeURI(this.campaign.Name)}&utm_term=${encodeURI(term)}&utm_content=${encodeURI(analyticsCode)}`.replace(/%20/g, "+");

            const templateValues = {
                StartTime: startDate.format(timeFormat),
                EndTime: endDate.format(timeFormat),
                StartDate: startDate.format(dateFormat),
                EndDate: endDate.format(dateFormat)
            };

            for (const comms of this.campaign.TemplateActions.Communications || []) {
                for (const message of comms.Messages || []) {
                    this.formatCommunicationMessage(
                        message,
                        templateValues,
                        shortURLResolved
                    );
                }
            }
        }

        /**
         * When the published start date has changed, then set the time constraints and fetch the allowed end dates
         */
        PublishStartDateChanged() {
            if (this.initialisingStartDate) {
                this.initialisingStartDate = false;
                return;
            }

            if (this.campaign.PublishStartDate) {
                this.campaign.LaunchDate = this.campaign.PublishStartDate;
                this.minStartTime = this.getMinVoucherTime(this.campaign.PublishStartDate);

                this.$timeout(() => {
                    this.campaign.PublishStartTime = this.minStartTime;
                    this.formatCommunicationMessages();
                }, 0);

                this.loadAvailableEndDates();
                this.loadAvailableCommunicationDates();
            }
        }

        /**
         * Return the time rounded up to the next 5th minute interval.
         * @param now {Date}
         * @returns {Date}
         */
        TimeRoundedUpToFiveMinutes(now) {
            // Return the time rounded up to the next 5th minute interval.
            // For example: if the time now is 5:32, this function will return 5:35
            now.setMinutes(5 * Math.ceil(now.getMinutes() / 5));
            return now;
        }

        setDefaultMaxVoucherTimes() {
            this.maxEndTime = this.LocalisationService.combineDateTime(
                this.campaign.PublishEndDate,
                "23:30"
            );

            this.maxStartTime = this.LocalisationService.combineDateTime(
                this.campaign.PublishStartDate,
                "23:55"
            );
        }

        setVoucherIsSameDayTimes() {
            this.minEndTime = this.maxEndTime;

            this.maxStartTime = this.LocalisationService.combineDateTime(
                this.campaign.PublishStartDate,
                "23:25"
            );
        }

        setVoucherStartTime() {
            let currentDate = new Date();

            if (
                this.isSameDay(
                    this.campaign.PublishStartDate,
                    currentDate
                )
            ) {
                currentDate = this.TimeRoundedUpToFiveMinutes(currentDate);

                this.campaign.PublishStartTime = this.LocalisationService.combineDateTime(
                    this.campaign.PublishStartDate,
                    this.LocalisationService.formatDateTime(currentDate, "HH:mm"));
            } else {
                this.campaign.PublishStartTime = this.LocalisationService.combineDateTime(
                    this.campaign.PublishStartDate,
                    "02:00");
            }
        }

        /**
         * When the published end date has changed, then set the time constraints
         */
        PublishEndDateChanged() {
            if (this.initialisingEndDate) {
                this.initialisingEndDate = false;
                return;
            }

            if (this.campaign.PublishEndDate) {
                this.minEndTime = this.campaign.PublishEndDate;
                this.setDefaultMaxVoucherTimes();

                if (
                    this.isSameDay(
                        this.campaign.PublishStartDate,
                        this.campaign.PublishEndDate
                    )
                ) {
                    this.setVoucherIsSameDayTimes();
                    this.setVoucherStartTime();
                }

                this.$timeout(() => {
                    this.campaign.PublishEndTime = this.maxEndTime;
                    this.formatCommunicationMessages();
                }, 0);
            }
        }

        /**
         * Load the available communication dates
         */
        loadAvailableCommunicationDates() {
            _.each(this.campaign.TemplateActions.Communications, comms => {
                const publishDate = this.LocalisationService.formatDateTime(
                    this.campaign.PublishStartDate,
                    "YYYY-MM-DD"
                );

                comms.AvailableMessageDates = comms.AvailableCommunicationDatesIncludingSundaysAndPublicHolidays
                    ? comms.AvailableCommunicationDatesIncludingSundaysAndPublicHolidays[publishDate]
                    : [];
                comms.WaspaCommunicationDates = comms.AvailableCommunicationDates
                    ? comms.AvailableCommunicationDates[publishDate]
                    : [];

                if (comms.AvailableMessageDates?.length > 0) {
                    comms.PublishDate = new Date(comms.AvailableMessageDates[0]);
                    this.callAndRecalculate(comms.commsPublishDateChanged);
                }
            });
        }

        /**
         * Loads available end dates based on the selected start date
         */
        loadAvailableEndDates() {
            this.CampaignsService.getCampaignTemplateValidEndDates(
                this.campaignTemplateId,
                this.userContext.StoreId,
                this.userContext.BrandId,
                this.campaign.PublishStartDate
            ).then(result => {
                    this.campaign.AvailableEndDates = result.data;

                    if (this.campaign.AvailableEndDates.length === 0) {
                        this.noAvailableEndDates = true;
                        return;
                    }

                    this.noAvailableEndDates = false;
                    this.endDateOptions.minDate = new Date(this.campaign.AvailableEndDates[0]);
                    this.endDateOptions.maxDate = new Date(
                        this.campaign.AvailableEndDates[
                        this.campaign.AvailableEndDates.length - 1
                            ]
                    );
                    this.campaign.PublishEndDate = this.endDateOptions.minDate;
                }, err => {
                    this.ErrorService.showError(
                        'An error occurred while loading the valid end dates for this campaign',
                        err
                    );
                }
            );
        }

        /**
         * Sets the disabled start dates based on the available start dates for the campaign
         * @param data {object}
         * @returns {boolean}
         */
        setDisabledStartDates(data) {
            const
                date = data.date,
                mode = data.mode;
            return mode === 'day' &&
                !this.CampaignWizardService.CheckIfDateAvailable(
                    date, this.campaign.AvailableStartDates
                );
        }

        /**
         * Sets the disabled end dates based on the available end dates for the campaign
         * @param data
         * @returns {boolean}
         */
        setDisabledEndDates(data) {
            const
                date = data.date,
                mode = data.mode;
            return mode === 'day' &&
                !this.CampaignWizardService.CheckIfDateAvailable(
                    date, this.campaign.AvailableEndDates
                );
        }

        /**
         * Recalculates all the calculated values for this campaign
         */
        recalculateValues() {
            let additionalCustomers = 0;

            // If the slider has been set to maximum allocation and the enrollment of additional new customers has been enabled,
            // add the max new customer allocation to the current result
            if (this.sliderCustomerCount === this.campaign.MaxCustomers
                && this.enrollAdditionalNewCustomers) {
                additionalCustomers = this.maxAdditionalNewCustomers;
            }

            this.campaign.SelectedCustomerCount = this.sliderCustomerCount + additionalCustomers;

            this.campaign.SelectedSMSCount =
                this.campaign.SelectedCustomerCount < this.campaign.CustomersOptedInForSMS
                    ? this.campaign.SelectedCustomerCount + additionalCustomers
                    : this.campaign.CustomersOptedInForSMS + additionalCustomers;

            this.CampaignWizardService.CalculateCommunicationsCosts(
                this.campaign.TemplateActions.Communications,
                this.campaign
            );
        }

        callAndRecalculate(callback) {
            callback(this.recalculateValues.bind(this));
        }

        /**
         * Shows the date picker control
         */
        openStartDatePicker() {
            this.startDateOptions.showDatePicker = true;
        }

        openPreview(messageType, message) {
            this.$uibModal.open({
                animation: true,
                templateUrl: 'components/campaigndesigner/managecampaigntemplates/commssetup/preview.a57bac9e.html',
                controller: 'PreviewModalController',
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    messageType: () => {
                        return messageType;
                    },
                    message: () => {
                        return message;
                    }
                }
            });
        }

        /**
         * Shows the date picker control
         */
        openEndDatePicker() {
            this.endDateOptions.showDatePicker = true;
        }

        /**
         * Fired when the selected customer count input lost focus to check that it contains a value, and if not
         * set it to the minimum which is 1 customer
         */
        validateCustomerCountInput() {
            if (
                !this.campaign.SelectedCustomerCount
                || isNaN(this.campaign.SelectedCustomerCount)
            ) {
                this.campaign.SelectedCustomerCount = 1;
            }
        }

        /**
         * This function is fired evaluate if we can activate the campaign based on the current rule requirements
         */
        canActivateCampaign() {
            if (!this.campaign) {
                return false;
            }

            this.ShowCustomerSlider = true;
            const hasValidEndDate = !this.noAvailableEndDates;
            const hasCustomers = this.ShowCustomerSlider && this.campaign.SelectedCustomerCount > 0;
            const canHaveNoCustomers = !this.ShowCustomerSlider;

            return hasValidEndDate && (hasCustomers || canHaveNoCustomers);
        }
    }

    angular
        .module("dashboard")
        .component("campaignWizardCustomise",
            {
                templateUrl: "components/campaigns/wizard/step-2/campaign-wizard-customise.d067a627.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$injector",
                    "PermissionService",
                    "$state",
                    "CampaignsService",
                    "LocalisationService",
                    "ErrorService",
                    "$uibModal",
                    "$timeout",
                    "SMSHelperService",
                    "CampaignWizardService",
                    "DashboardConfig",
                    "moment",
                    "$element",
                    CampaignWizardCustomiseController ]
            });
})();
